import get from 'lodash/get'

export const isEnabled = (channelData) => {

  const features = get(channelData, 'features')
  if (!features || !Array.isArray(features)) {

    return false

  }

  return !!features.find(({ name, enabled }) => name === 'nurture' && enabled === true)

}

